var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShared(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38.433,
    height: 35,
    viewBox: "0 0 38.433 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M428.588,279.69a6.38,6.38,0,0,1-.445,1.659,5.675,5.675,0,0,1-4.671,3.521,5.821,5.821,0,0,1-6.526-4.939,3.057,3.057,0,0,1-.046-.526c0-.158-.062-.215-.206-.244q-1.594-.316-3.186-.643l-6.964-1.424c-1.157-.237-2.315-.47-3.472-.711a.258.258,0,0,0-.326.155,6.539,6.539,0,0,1-5.111,3.5,6.695,6.695,0,0,1-1.948-13.242,6.517,6.517,0,0,1,5.44,1.459c.158.129.24.118.382-.016q3.763-3.551,7.535-7.092,1.05-.987,2.106-1.965c.113-.1.107-.176.031-.295a5.671,5.671,0,0,1-.9-3.158,5.884,5.884,0,1,1,2.835,5.051.249.249,0,0,0-.377.054q-2.8,3-5.609,6-1.928,2.06-3.858,4.119a.281.281,0,0,0-.072.331,6.182,6.182,0,0,1,.335,1.744.238.238,0,0,0,.207.254q3.464.919,6.926,1.846,3.217.859,6.432,1.722c.166.045.224,0,.29-.147a5.665,5.665,0,0,1,4.638-3.448,5.829,5.829,0,0,1,6.532,5.048c.006.045.019.089.029.133Z",
    transform: "translate(-390.155 -249.919)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShared);
export default __webpack_public_path__ + "static/media/shared.f1be325b7f67b2b9095bb60d7aab29fc.svg";
export { ForwardRef as ReactComponent };